/**
 *
 * Material UI styles for Body2
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const styles = theme => ({
  root: {
    color: ({ color }) =>
      // can only use common palette
      color ? theme.palette.common[color] : theme.palette.common.gray600,
  },
});

export default styles;
